// @flow

import React from 'react';
import takeWhile from 'lodash/takeWhile';
import filter from 'lodash/filter';

import {gt, ngt} from 'app/utils/i18n';
import {SidebarItem} from 'app/general/structures/SidebarItem';

type AnyVersionType = any;

function tooltipText(drafts: number) {
  return (
    <div>
      <div>{gt('Versions')}</div>
      {drafts > 0 && (
        <div>{ngt('%s pending draft', '%s pending drafts', drafts)}</div>
      )}
    </div>
  );
}

function getRecentVersions(versions: AnyVersionType[]): AnyVersionType[] {
  return takeWhile(
    versions,
    (version) => !(version.is_current && version.approved_at)
  );
}

function getNumDrafts(recentVersions: Array<AnyVersionType>): number {
  return filter(recentVersions, {approved_at: null}).length;
}

type Props = {|
  collapsed: boolean,
  versions: Array<AnyVersionType>,
  link?:
    | string
    | {
        pathname: string,
        search?: string,
        hash?: string,
        state?: {},
      }
    | (() => string),
  onClick?: (ev: SyntheticEvent<any>) => void,
  active?: boolean,
  forceTooltipShow?: boolean,
|};

class VersionsSidebarItem extends React.PureComponent<Props> {
  render() {
    const {collapsed, versions, ...other} = this.props;

    const recentVersions = getRecentVersions(versions);
    const numDrafts = getNumDrafts(recentVersions);

    return (
      <SidebarItem
        title={tooltipText(numDrafts)}
        icon={collapsed ? 'fa fa-chevron-right' : 'far fa-clock'}
        badge={numDrafts > 0 ? numDrafts : undefined}
        {...other}
      />
    );
  }
}

export default VersionsSidebarItem;
